// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const xurkitree: PokeData = {
  "id": 796,
  "name": "xurkitree",
  "height": 38,
  "weight": 1000,
  "base_experience": 257,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "thunder-punch",
    "wrap",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "hypnosis",
    "zap-cannon",
    "spark",
    "charge",
    "ingrain",
    "tail-glow",
    "signal-beam",
    "shock-wave",
    "magnet-rise",
    "discharge",
    "power-whip",
    "ion-deluge",
    "eerie-impulse",
    "electric-terrain"
  ],
  "moves": [
    "thunder-punch",
    "thunder-shock",
    "thunderbolt",
    "zap-cannon",
    "power-whip",
    "electric-terrain",
    "thunder",
    "quick-tempo",
    "wild-charge",
    "electric-wrath",
    "thunder-fang",
    "volt-crash",
    "volt-switch"
  ],
  "evolution_chain": {
    "id": 417,
    "item": null,
    "species": [
      {
        "name": "xurkitree",
        "order": 796,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 92,
    "speed": 100,
    "ability_power": 208
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
